import ShareIcon from "@/common/images/icons/share.svg?react";
import SoundOffIcon from "@/common/images/icons/soundOffIcon.svg?react";
import SoundOnIcon from "@/common/images/icons/soundOnIcon.svg?react";
import FullScreenIcon from "@/common/images/icons/fullScreenIcon.svg?react";
import ExitFullScreenIcon from "@/common/images/icons/exitFullScreen.svg?react";
import SDIcon from "@/common/images/icons/sd.svg?react";
import HDIcon from "@/common/images/icons/hd.svg?react";

import { Actions } from "./types";

export const VideoButtons = (props: {
  hasSound: boolean;
  fullScreen: boolean;
  hd: boolean;
  muted: boolean;
  haveFullScreen: boolean;
  onClick: (value: Actions) => void;
}): JSX.Element => {
  const onClick = (id: Actions) => () => {
    props.onClick(id);
  };

  return (
    <div className="buttons">
      {props.hasSound && props.muted && (
        <div className="button">
          <SoundOffIcon
            className="soundOff"
            onClick={onClick(Actions.UnMute)}
          />
          <span>Off</span>
        </div>
      )}

      {props.hasSound && !props.muted && (
        <div className="button">
          <SoundOnIcon
            className="soundOn"
            onClick={onClick(Actions.Mute)}
          />
          <span>On</span>
        </div>
      )}
      {props.haveFullScreen && (
        <div className="button">
          {props.fullScreen && (
            <ExitFullScreenIcon
              className="exitFullScreen"
              onClick={onClick(Actions.FullScreen)}
            />
          )}

          {!props.fullScreen && (
            <FullScreenIcon
              className="fullScreen"
              onClick={onClick(Actions.FullScreen)}
            />
          )}
        </div>
      )}

      {props.hd && (
        <div onClick={onClick(Actions.SD)} className="button">
          <HDIcon className="gifQuality" />
        </div>
      )}

      {!props.hd && (
        <div onClick={onClick(Actions.HD)} className="button">
          <SDIcon className="gifQuality" />
        </div>
      )}

      <div className="button" id="shareButton">
        <ShareIcon
          onClick={onClick(Actions.Share)}
        />
      </div>
    </div>
  );
};
